import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/layout/layoutHf'
// import Index from '@/views/index'
// import Video from '@/views/video'
// import Personal from '@/views/personal'
// import notFound from '@/views/404'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: '/edu-pc/',
  routes: [
    {
      path: '/',
      name: 'Layout',
      component: Layout,
      redirect: 'Index',
      children: [
        {
          path: 'index',
          name: 'Index',
          component (resolve) {
            require(['@/views/index'], resolve)
          }
        },
        {
          path: 'mine',
          name: 'Mine',
          component (resolve) {
            require(['@/views/mine'], resolve)
          }
        },
        // 搜索进入的页面
        {
          path: 'search',
          name: 'Search',
          component (resolve) {
            require(['@/views/search'], resolve)
          }
        },
        {
          path: 'video/:courseId',
          name: 'Video',
          component (resolve) {
            require(['@/views/video'], resolve)
          }
        },
        {
          path: 'index/personal',
          name: 'Personal',
          component (resolve) {
            require(['@/views/personal'], resolve)
          }
        },
        {
          path: '/spot',
          name: 'Spot',
          component (resolve) {
            require(['@/views/pathologySpot'], resolve)
          }
        }
      ]
    },
    {
      path: '/404',
      component (resolve) {
        require(['@/views/404'], resolve)
      },
      name: 'Page404'
    },
    { path: '*', redirect: '/404', hidden: true }
  ],
  scrollBehavior (to, from, savedPosition) {
    return {
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js